/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Other_FeedbackInputs */

const en_footer_other_feedback = /** @type {(inputs: Footer_Other_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit feedback`)
};

/**
* | output |
* | --- |
* | "Submit feedback" |
*
* @param {Footer_Other_FeedbackInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_other_feedback = /** @type {((inputs?: Footer_Other_FeedbackInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Other_FeedbackInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_other_feedback(inputs)
});